(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dz-scent-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-dz-minus], [data-dz-plus]');
    if (!button) return;
    var control = button.closest('[data-dz-quantity]');
    var input = control && control.querySelector('input[name="quantity"]');
    if (!input) return;
    var current = parseInt(input.value, 10) || 1;
    input.value = button.hasAttribute('data-dz-minus') ? Math.max(1, current - 1) : current + 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
